import btnClose from '@/components/btnClose/btnClose.vue'
import CustomInput from '@/components/CustomInput/CustomInput.vue'
import { mapGetters, mapActions } from "vuex";
import facebookLogin from 'facebook-login-vuejs';
import InfoMessage from "../../AlertMessage/InfoMessage.vue";
import Preloader from "../../Preloader/Preloader.vue";
import api_requests from "@/store/api/api_requests";

export default {
    name: 'loginModal',
    components: {
        btnClose, CustomInput, facebookLogin, InfoMessage, Preloader
    },
    props: {
        nonModal: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            form_data: [
                {
                    id: 0,
                    field: 'email',
                    value: '',
                    empty: true,
                    validity: true
                },
                {
                    id: 1,
                    field: 'password',
                    value: '',
                    empty: true,
                    validity: true
                },
            ],
            avatar: '',
            errorAuth: false,
            errors: '',
            successAuth: false,
            isConnected: false,
            FB: undefined,
            preloading: false
        }
    },
    methods: {
        ...mapActions(['changeVisionSignUp', 'changeVisionLogin', 'resetError']),
        getField(field_name) {
            return this.form_data.find(v => v.field === field_name)
        },
        inputField(field_name, value) {
            let field = this.form_data.find(v => v.field === field_name)
            field.value = value.inp
            field.empty = value.inp.length === 0
            field.validity = !value.invalide
            if (field_name === 'c_password') {
                field.validity = !value.invalide && field.value === this.getField('password').value
            }
        },
        getError(field_name) {
            return this.errors.find(v=> v.field === field_name)
        },
        removeErrorByField(field_name) {
            const errorObjIndex = this.errors.indexOf(this.getError(field_name))
            if (errorObjIndex !== -1) {
                this.errors.splice(errorObjIndex, 1)
            }
        },
        async getUserData() {
            return await this.$store.dispatch('loginFB', null).then(resp => {
                if (resp.status === 200) {
                    this.errorAuth = false
                    this.successAuth = true
                    this.$router.push('/my-gates')
                } else {
                    this.errorAuth = true
                }
            })
        },
        submitHandler() {
            this.preloading = true
            if (!this.email.invalide && !this.password.invalide) {
                const formData = {
                    email: this.getField('email').value,
                    password: this.getField('password').value
                }
                this.$store.dispatch('login_v2', formData)
                    .then(resp => {
                        if (resp.status !== 200) {
                            this.preloading = false
                        } else {
                            this.preloading = false
                            this.successAuth = true
                            this.$router.push('/my-gates').then(r => console.log(r))
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event' : 'login',
                                'method' : 'email',
                                'userId' : localStorage.getItem('user') ? localStorage.getItem('user')['id'] : null
                            });
                        }
                    })
                    .catch((error)=>{
                        this.preloading = false
                        this.errors = error.response.data.message
                    })
            } else {
                this.errorAuth = true
            }
        },
        onLogin() {
            this.getUserData()
        },
        onLogout() {
            this.$store.dispatch('logoutFB')
            this.isConnected = false;
        },
        changeVision() {
            this.changeVisionLogin()
        },
        toSignUp() {
            if (!this.$props.nonModal) {
                this.changeVisionLogin()
                this.changeVisionSignUp()
            } else {
                this.$router.push('/registration');
            }
        },
        toSuccess() {
            this.changeVisionLogin()
            this.changeVisionSuccess()
        },
        sendEventResetPassword() {
            api_requests.send_event_reset_password();
        }
    },
    watch: {
        email () {
            this.errors = ''
        },
        password () {
            this.errors = ''
        },
    },
    computed: {
        ...mapGetters({
            authErrors: 'authErrors'
        }),
        email () {
            return this.getField('email').value
        },
        password () {
            return this.getField('password').value
        },
        toogleLogin() {
            return this.$store.getters.toogleLogin
        }
    }

    // computed: mapGetters(['toogleLogin', 'getFB']),
}
